import { Elements } from '@stripe/react-stripe-js';
import { PaymentCardForm } from '../PaymentCardForm/PaymentCardForm';
import { Loading } from '../Loading/Loading';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { createIntent } from '@app/services/plans';

const stripePromise = loadStripe(import.meta.env.VITE_APP_STRIPE_KEY);

export const PaymentMethodForm = ({
  cancelAction,
  onSuccess,
}: {
  cancelAction: () => void;
  onSuccess?: () => void;
}) => {
  const [clientSecret, setClientSecret] = useState('');
  const [loadingStripe, setLoadingStripe] = useState(true);

  useEffect(() => {
    const fetchClientSecret = async () => {
      setLoadingStripe(true);
      const response = await createIntent();

      setClientSecret(response.data.intent);
      setLoadingStripe(false);
    };

    fetchClientSecret();
  }, []);

  if (loadingStripe || !clientSecret) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loading />
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <PaymentCardForm
        clientSecret={clientSecret}
        cancelAction={cancelAction}
        onSuccess={onSuccess}
      />
    </Elements>
  );
};
